import { render, staticRenderFns } from "./AlertNotificacoes.vue?vue&type=template&id=56bd9f60&scoped=true"
import script from "./AlertNotificacoes.vue?vue&type=script&lang=js"
export * from "./AlertNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./AlertNotificacoes.vue?vue&type=style&index=0&id=56bd9f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd9f60",
  null
  
)

export default component.exports